import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import VideoPlayer from '@/components/CampaignPages/PublicPage/VideoPlayer';
import { resolveVideoThumbnailUrl, VIMEO_REGEX } from '@/components/CampaignPages/utils/video';
import styles from './sections.module.scss';

const StorySection = ({ colors, heading, body, video, preview = false, mobileLayout = false, videoThumbnailSlot }) => {
  const [videoPlaying, setVideoPlaying] = useState(false);
  const [vimeoThumbnail, setVimeoThumbnail] = useState(null);

  const hasVideo = video && video.type && video.type !== 'none' && video.url;

  useEffect(() => {
    if (!hasVideo || video.type !== 'vimeo' || video.thumbnailUrl || !video.url) {
      setVimeoThumbnail(null);
      return;
    }

    const match = video.url.match(VIMEO_REGEX);
    if (!match) return;

    let cancelled = false;
    fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${match[1]}`)
      .then(res => (res.ok ? res.json() : null))
      .then(data => {
        if (!cancelled && data?.thumbnail_url) setVimeoThumbnail(data.thumbnail_url);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [hasVideo, video?.type, video?.url, video?.thumbnailUrl]);

  const videoThumbnailUrl = hasVideo ? resolveVideoThumbnailUrl(video.type, video.url, video.thumbnailUrl) : null;
  const displayVideoThumbnail = videoThumbnailUrl || vimeoThumbnail;

  return (
    <section className={classNames(styles.story, mobileLayout && styles.storyMobile)}>
      <div className={styles.container}>
        <div className={classNames(styles.storyGrid, !hasVideo && styles.storyGridSingle)}>
          <div>
            <p className={styles.sectionLabel} style={{ color: colors.accent }}>
              OUR STORY
            </p>
            {heading && (
              <>
                <h2 className={styles.sectionHeading} style={{ color: colors.third }}>
                  {heading}
                </h2>
                <div className={styles.storyDivider} style={{ background: colors.accent }} />
              </>
            )}
            {body && (
              <div className={styles.storyBody} style={{ color: colors.third }}>
                {body}
              </div>
            )}
          </div>
          {hasVideo && (
            <div className={styles.videoWrapper}>
              {videoPlaying ? (
                <VideoPlayer videoType={video.type} videoUrl={video.url} posterUrl={displayVideoThumbnail} autoplay />
              ) : (
                <div
                  className={styles.videoThumbnail}
                  onClick={() => !preview && setVideoPlaying(true)}
                  onKeyDown={e => e.key === 'Enter' && !preview && setVideoPlaying(true)}
                  role="button"
                  tabIndex={preview ? -1 : 0}
                >
                  {videoThumbnailSlot ||
                    (displayVideoThumbnail ? (
                      <img src={displayVideoThumbnail} alt="Video thumbnail" />
                    ) : (
                      video.type === 'uploaded' && (
                        <video src={video.url} muted playsInline preload="metadata" className={styles.videoPoster} />
                      )
                    ))}
                  <div className={styles.videoPlayBtn}>
                    <img src="/static/icons/webpage/video-play-button.png" alt="Play" />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default StorySection;
